import { effects } from 'redux-saga'

import { begin, end, receiveError } from '../../modules/loading'
import { receiveServices } from '../../modules/service/reducer'
import callWithHmac from '../effects/callWithHmac'

export default function* loadClient(invocation, action) {
  const ips = action.payload.ips

  try {
    yield effects.put.resolve(begin('service-ip', ips))

    const result = yield effects.call(
      callWithHmac,
      invocation.getServicesByIps,
      ips,
    )

    yield effects.put.resolve(receiveServices(result.services))
  } catch (e) {
    if (!e.response || e.response.status >= 500) {
      throw e
    }

    yield effects.put.resolve(receiveError('service-ip', ips, e))
  } finally {
    yield effects.put.resolve(end('service-ip', ips))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/loadIp.js